import v5_model from '@/models/v5/model';

const DeviceGroupProfile = v5_model.extend({
    fetch: function() { return false; }
});
DeviceGroupProfile.type = 'devicegroup_profile';

export default DeviceGroupProfile;
